var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScanBarcode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9V6.5C2.5 4.01 4.51 2 7 2H9.5",
    stroke: "#005DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2H18C20.49 2 22.5 4.01 22.5 6.5V9",
    stroke: "#005DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16V17.5C22.5 19.99 20.49 22 18 22H16.5",
    stroke: "#005DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 22H7C4.51 22 2.5 19.99 2.5 17.5V15",
    stroke: "#005DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7V9C11 10 10.5 10.5 9.5 10.5H7.5C6.5 10.5 6 10 6 9V7C6 6 6.5 5.5 7.5 5.5H9.5C10.5 5.5 11 6 11 7Z",
    stroke: "#005DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7V9C19 10 18.5 10.5 17.5 10.5H15.5C14.5 10.5 14 10 14 9V7C14 6 14.5 5.5 15.5 5.5H17.5C18.5 5.5 19 6 19 7Z",
    stroke: "#005DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15V17C11 18 10.5 18.5 9.5 18.5H7.5C6.5 18.5 6 18 6 17V15C6 14 6.5 13.5 7.5 13.5H9.5C10.5 13.5 11 14 11 15Z",
    stroke: "#005DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15V17C19 18 18.5 18.5 17.5 18.5H15.5C14.5 18.5 14 18 14 17V15C14 14 14.5 13.5 15.5 13.5H17.5C18.5 13.5 19 14 19 15Z",
    stroke: "#005DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanBarcode);
export default __webpack_public_path__ + "static/media/scan-barcode.413745be7273546f32c39d9680e26c04.svg";
export { ForwardRef as ReactComponent };